import styled from 'styled-components'
import Slider from 'react-slick'

export const CustomSlide = styled.div`
  @media screen and (min-width: 1100px) {
    padding: 30px 48px 48px 48px;

  }

`

export const CustomSlider = styled(Slider)`
  display: grid !important;

  .slick-track {
    outline: none;
  }

  .slick-dots {
    bottom: 33px;
    @media screen and (max-width: 1099px){
    bottom: -3px;
    }

    li, button {
      width: 8px;
      height: 8px;
    }

    li button:before {
      content: '';
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background-color: ${props => props.theme.color.grey1};
      opacity: 1;
    }

    li.slick-active {
      width: 30px;

      button {
        width: 30px;
      }
    }

    li.slick-active button:before {
      opacity: 1;
      width: 30px;
      border-radius: 4px;
      transition: 0.3s;
      background-color: ${props => props.theme.color.red2};
    }

  }

  @media screen and (min-width: 1100px) {
    max-height: 324px;

    .slick-dots {
      li button:before {
        width: 8px;
        height: 8px;
      }
    }
  }

`

export const ProductImageSlider = styled(Slider)`
  display: grid !important;
  @media screen and (min-width: 1100px) {
    .slick-dots {
      position: static;
      display: block;

      li {
        width: 80px;
        height: 80px;
        padding: 10px;
        border: 1px solid #eaeaea;
        box-sizing: border-box;
        background-color: white;

        img {
          object-fit: contain;
        }
      }
    }

    .product-image {
      display: flex !important;
      justify-content: center;
      margin-bottom: 8px;

      div {
        outline: none;
      }

    }
  }

`

export const ProductPictureSmall = styled.img`
  width: 100%;
  height: 100%;
  @media screen and (min-width: 1100px) {

  }
`

export const ProductItemsSlider = styled(Slider)`
  display: grid !important;


  .slick-track {
    display: flex !important;
    background: white;
    padding-bottom:18px
  }



  .slick-slide > div:not(:only-child) {
    margin-top: 16px;
  }

  .slick-slide {
    div {
      outline: none;
    }

    &:not(:first-child) {
      margin-left: 16px;
    }

    img {
      display: inline-block;
    }
  }

  .slick-arrow {
    top: -30px;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    border: 3px solid #872867;
    
    &:before {
      display: none;
    }

    &.slick-prev {
      position: absolute;
      right: 50px;
      left: unset;


      //left: -45px;
      //@media screen and (max-width: 1100px){
      //  left: -28px;
      //}
      background: url('/img/arrow-left-orange.svg') center no-repeat;

      &.slick-disabled {
        border-color: #D2D2D2;
        background: url('/img/arrow-left-grey.svg') center no-repeat;
      }
    }

    &.slick-next {

      right: 0;
      background: url('/img/arrow-right-orange.svg') center no-repeat;

      &.slick-disabled {
        border-color: #D2D2D2;
        background: url('/img/arrow-right-grey.svg') center no-repeat;
      }
    }

  }

  @media screen and (min-width: 1100px) {

  }

`

export const CommentImageSlider = styled(Slider)`
  display: grid !important;
  max-width: 300px;
  padding-top: 65px;

  div {
    outline: none;
  }

  .comment-image-slide {
    img {
      width: 300px;
      height: 170px;
    }
  }

  .slick-list {
    width: 300px;
    height: 170px;
    border-radius: 6px;
    border: 1px solid #DFE3E9;
  }

  ul.slick-dots {
    bottom: unset;
    top: 0px;
    text-align: left;

    li {
      width: 50px;
      height: 50px;
      border: 1px solid #DFE3E9;
      border-radius: 4px;

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;

        img {
          width: 40px
          height: 40px;
        }
      }

      &.slick-active {
        border-color: ${props => props.theme.color.orange};
      }

    }
  }


  .slick-arrow {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    border: 1px solid #FFAD00;
    z-index: 999;
    top: 63%;

    &.slick-prev {
      left: 14px;
      background: url('/img/arrow-left-orange.svg') center no-repeat;

      &.slick-disabled {
        border-color: #D2D2D2;
        background: url('/img/arrow-left-grey.svg') center no-repeat;
      }
    }

    &.slick-next {
      right: 14px;
      background: url('/img/arrow-right-orange.svg') center no-repeat;

      &.slick-disabled {
        border-color: #D2D2D2;
        background: url('/img/arrow-right-grey.svg') center no-repeat;
      }
    }
  }

  @media screen and (min-width: 1100px) {
  }


`


export const RightPaneItems = styled.div`
  .product-item{
    &:not(:first-child){
      margin-top: 10px;
    }
  }
`

export const RightPaneRelatedTitle= styled.div`
  margin:10px;
  h2{
    color: ${props=>props.theme.color.grey2};
    font-family: ${props=>props.theme.font.family.medium};
    font-size: 20px;
    text-align: center;
  }
`
